<template>
  <div>
    <a-drawer title="Add Account Item " :placement="'right'" :visible="add_subaccout_item_visible" width="900"
      v-if="active_tab !== 'summary'">
      <a-form :layout="'horizontal'">
        <a-form-item label="Add to Account/Sub Account" v-if="
          voyage_accounts.find((v) => v.id == active_tab).accounts[selected_account_pos]
            .sub_accounts.length > 0
        ">
          <span style="font-weight: bolder">{{
            voyage_accounts.find((v) => v.id == active_tab).accounts[selected_account_pos]
              .account_name
          }}</span>
          /
          <span style="font-weight: bolder">
            {{
              voyage_accounts.find((v) => v.id == active_tab).accounts[
                selected_account_pos
              ].sub_accounts[selected_subaccount_pos].sub_account_name
            }}</span>
        </a-form-item>
        <a-tabs :value="'multi_items'" @change="
          (e) => {
            if (e == 'single_item') {
              new_item.calc_type = 'one';
              new_item.props = [''];
            }
            if (e == 'multi_period_items') {
              new_item.calc_type = 'period';
              new_item.props = [''];
            }
          }
        ">
          <a-tab-pane tab="Single Item" key="single_item">
            <a-form-item label="Item Name">
              <a-input v-model="new_item.item_name"></a-input>
            </a-form-item>
            <a-form-item label="Debit / Credit">
              <a-radio-group size="small" button-style="solid" v-model="new_item.debit_credit">
                <a-radio-button :value="'debit'"> Debit </a-radio-button>
                <a-radio-button :value="'credit'"> Credit </a-radio-button>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="Calc Type">
              <a-radio-group size="small" button-style="solid" v-model="new_item.calc_type" @change="
                () => {
                  if (new_item.calc_type == 'two') {
                    new_item.props = ['FREIGHT', 'TONS'];
                  }
                  if (new_item.calc_type == 'period') {
                    new_item.props = ['DAILY_HIRE'];
                  }
                  if (new_item.calc_type == 'one') {
                    new_item.props = ['LUMP SUM'];
                  }
                }
              ">
                <a-radio-button :value="'one'"> One Value(Lump Sum) </a-radio-button>
                <a-radio-button :value="'two'"> Two Value(Multiply) </a-radio-button>
                <a-radio-button :value="'period'"> Time Period </a-radio-button>
                <a-radio-button :value="'percentage'">Percentage({{
                  new_item.debit_credit == "credit"
                    ? "As Credit Agaist All Debit"
                    : "As Debit Against All Credit"
                }})</a-radio-button>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="Value Name" v-if="
              (new_item.calc_type == 'one') |
              (new_item.calc_type == 'period') |
              (new_item.calc_type == 'percentage')
            ">
              <a-input v-model="new_item.props[0]"></a-input>
            </a-form-item>
            <a-form-item label="Value Names" v-if="new_item.calc_type == 'two'">
              <a-input v-model="new_item.props[0]"></a-input>
              <a-input v-model="new_item.props[1]"></a-input>
            </a-form-item>
            <a-form-item>
              <a-space>
                <a-button type="primary" @click="
                  () => {
                    add_subaccout_item_visible = false;
                    let i = { ...new_item };
                    new_item.props = [''];
                    i.props.forEach((p) => {
                      p = p.replace(' ', '_');
                      i['value_' + p] = 0;
                    });
                    delete i.props;
                    if (i.calc_type == 'period') {
                      i.period = [];
                    }
                    voyage_accounts
                      .find((v) => v.id == active_tab)
                      .accounts[selected_account_pos].sub_accounts[
                      selected_subaccount_pos
                    ].breakdown.push(i);
                  }
                ">Create</a-button>
                <a-button @click="
                  () => {
                    add_subaccout_item_visible = false;
                  }
                ">
                  Cancel</a-button>
              </a-space>
            </a-form-item>
          </a-tab-pane>
          <a-tab-pane tab="Multi Periods Items" key="multi_period_items">
            <a-form-item label="Item Name Prefix">
              <a-input v-model="new_item.item_name"></a-input>
            </a-form-item>
            <a-form-item label="Debit / Credit">
              <a-radio-group button-style="solid" v-model="new_item.debit_credit">
                <a-radio-button :value="'debit'"> Debit </a-radio-button>
                <a-radio-button :value="'credit'"> Credit </a-radio-button>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="Value Name">
              <a-input v-model="new_item.props[0]"></a-input>
            </a-form-item>
            <a-form-item label="Total Period /  First Time Node /  Leg Duration">
              <a-space>
                <a-input-group compact>
                  <a-input style="width: 20%; text-align: center" placeholder="From"
                    v-model="multi_period_items.total_period[0]" />
                  <a-input style="
                      width: 60px;
                      border-left: 0;
                      pointer-events: none;
                      background-color: #fff;
                      text-align: center;
                    " placeholder="~" disabled />
                  <a-input style="width: 20%; text-align: center; border-left: 0" placeholder="To"
                    v-model="multi_period_items.total_period[1]" />
                  <a-input style="width: 20%" v-model="multi_period_items.first_time_node" />
                  <a-input style="width: 20%" v-model="multi_period_items.duration" type="number" step="1"></a-input>
                </a-input-group>
              </a-space>
            </a-form-item>
            <a-form-item label="Time Nodes">
              <a-input-group compact v-for="(t, t_pos) in time_node" :key="t_pos">
                <a-input v-model="time_node[t_pos]" style="width: 200px" />
                <a-popconfirm placement="topLeft" ok-text="Split" cancel-text="Cancel"
                  v-if="t_pos !== time_node.length - 1" @cancel="
                    () => {
                      temp_time_for_split = '';
                    }
                  " @confirm="
                    () => {
                      if (temp_time_for_split == '') {
                        MESSAGE.error('Please Enter a Time to Split');
                        return;
                      }

                      if (
                        moment(temp_time_for_split).diff(
                          moment(time_node[t_pos]),
                          'days',
                          true
                        ) < 0
                      ) {
                        MESSAGE.error('No Early Than ' + time_node[t_pos]);
                        return;
                      }
                      if (
                        moment(temp_time_for_split).diff(
                          moment(time_node[t_pos + 1]),
                          'days',
                          true
                        ) > 0
                      ) {
                        MESSAGE.error('No Later Than ' + time_node[t_pos + 1]);
                        return;
                      }
                      time_node.splice(t_pos + 1, 0, temp_time_for_split);
                      temp_time_for_split = '';
                    }
                  ">
                  <template slot="title">
                    <p>By Adding Another Node to Split the Period</p>
                    <a-date-picker v-model="temp_time_for_split" valueFormat="YYYY/MM/DD HH:mm:ss"
                      format="YYYY/MM/DD HH:mm:ss" showTime></a-date-picker>
                  </template>
                  <a-button type="primary">SPLIT</a-button>
                </a-popconfirm>
              </a-input-group>
            </a-form-item>
            <a-form-item>
              <a-space>
                <a-button type="primary" @click="
                  () => {
                    add_subaccout_item_visible = false;
                    let item_name_prefix = new_item.item_name;

                    let t = 0;
                    while (t < time_node.length - 1) {
                      let i = { ...new_item };
                      i.item_name = item_name_prefix + ' ' + (t + 1);
                      i.period = [time_node[t], time_node[t + 1]];
                      new_item.props.forEach((p) => {
                        p = p.replace(' ', '_');
                        i['value_' + p] = '';
                      });
                      delete i.props;
                      voyage_accounts
                        .find((v) => v.id == active_tab)
                        .accounts[selected_account_pos].sub_accounts[
                        selected_subaccount_pos
                      ].breakdown.push(i);
                      t++;
                    }
                  }
                ">Create</a-button>
                <a-button @click="
                  () => {
                    add_subaccout_item_visible = false;
                  }
                ">
                  Cancel</a-button>
              </a-space>
            </a-form-item>
          </a-tab-pane>
        </a-tabs>
      </a-form>
    </a-drawer>
    <a-tabs v-model="active_tab" type="editable-card" @edit="
      (e, action) => {
        if (action == 'add') {
          request(base_url + '/voyage_account/c', {
            accounts: [
              { account_name: 'Owner', sub_accounts: [] },
              { account_name: 'Charterer', sub_accounts: [] },
              { account_name: 'Administrative', sub_accounts: [] },
            ],
          }).then((r) => {
            if (r.data.status == 1) {
              let d = r.data.data[0];
              voyage_accounts.push(d);
              MESSAGE.success('Create Successfully');
              voyage_accounts_opened_ids.push(d.id);
              active_tab = d.id;
            }
          });
        } else {
          if (e !== 'summary') {
            let va = voyage_accounts.find((v) => v.id == e);
            request(base_url + '/voyage_account/u', va).then((r) => {
              if (r.data.status == 1) {
                MESSAGE.success(va.mv + ' Save Successfully');
                let pos = voyage_accounts_opened_ids.findIndex((vid) => vid == e);
                voyage_accounts_opened_ids.splice(pos, 1);
                voyage_accounts_opened_pos.splice(pos, 1);
                active_tab = 'summary';
              }
            });
          }
        }
      }
    ">
      <a-tab-pane tab="Summary" key="summary" class="summary_tab">
        <a-tabs default-active-key="summary_new">
          <a-tab-pane key="summary_new" tab="Summary(New)">
            <a-form layout="inline">
              <a-form-item label="Type of Summary">
                <a-select style="width: 200px" v-model="type_of_summary" @change="
                  () => {
                    summary_cols = [];
                    summary_data = [];
                  }
                ">
                  <a-select-option :value="'month'"> By Month </a-select-option>
                  <a-select-option :value="'vessel'"> By Vessel </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="
                  () => {
                    if (type_of_summary == 'month') {
                      summary_cols = account_by_month_utils.cols;
                      account_by_month_utils.data = this.voyage_accounts.sort(
                        account_by_month_utils.sort_by_month
                      );
                      summary_data = account_by_month_utils.data;
                    }

                    if (type_of_summary == 'vessel') {
                      summary_cols = account_by_vessel_utils.cols;
                      account_by_vessel_utils.data = this.voyage_accounts.sort(
                        account_by_vessel_utils.sort_by_veseel
                      );
                      summary_data = account_by_vessel_utils.data;
                    }
                  }
                ">Refresh</a-button>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="
                  () => {
                    if (summary_data.length == 0) {
                      MESSAGE.error('No Data to Export');
                      return;
                    } else {
                      summary_to_excel(summary_data);
                    }
                  }
                ">
                  Export to Excel
                </a-button>
              </a-form-item>
            </a-form>
            <a-table rowKey="id" :columns="summary_cols" :data-source="summary_data"
              :pagination="summary_table_pagination" bordered>
              <template slot="charter_voyage" slot-scope="record">
                <div>
                  <a-tag color="blue" style="
                      margin: 5px;
                      width: 100%;
                      white-space: normal;
                      text-align: center;
                    ">
                    {{ record.charterer }}
                  </a-tag>
                </div>
                <a-divider></a-divider>
                <div style="text-align: center">
                  <a-space>
                    <a-tag color="blue" style="margin: 5px">
                      {{ record.leg }}
                    </a-tag>
                    <a-tag color="blue" style="margin: 5px">
                      {{ record.charter_type }}
                    </a-tag>
                  </a-space>
                </div>
              </template>
              <template slot="vessel_voyage_charter" slot-scope="record">
                <div>
                  <a-tag color="blue" style="
                      margin: 5px;
                      width: 100%;
                      white-space: normal;
                      text-align: center;
                    ">
                    {{ record.charterer }}
                  </a-tag>
                </div>
                <div>
                  <a-tag color="blue" style="
                      margin: 5px;
                      width: 100%;
                      white-space: normal;
                      text-align: center;
                    ">
                    {{ record.mv }}
                  </a-tag>
                </div>
                <a-divider></a-divider>
                <a-space>
                  <a-tag color="blue">
                    {{ record.leg }}
                  </a-tag>
                  <a-tag color="blue">
                    {{ record.charter_type }}
                  </a-tag>
                </a-space>
              </template>
              <template slot="laycan" slot-scope="record">
                <div>Voyage year:</div>
                <div>{{ record.voyage_year }}</div>
                <a-divider></a-divider>
                <div>{{ record.laycan[0] }}</div>
                ~
                <div>
                  {{ record.laycan[1] }}
                </div>
              </template>
              <template slot="load_disc_port" slot-scope="record, index">
                {{ record.load_port }} ~ {{ record.disc_port }}
                <a-divider></a-divider>
                <div v-for="(sy, sy_pos) in record.port_stay" :key="'summary_port_stay_load' + index + sy_pos">
                  <a-space v-if="sy.type == 'load'">
                    <a-tag color="blue">{{ sy.name }}:{{
                      moment(sy.stay[1])
                        .diff(moment(sy.stay[0]), "days", true)
                        .toLocaleString()
                    }}
                      Days</a-tag>
                  </a-space>
                </div>
                <div v-for="(sy, sy_pos) in record.port_stay" :key="'summary_port_stay_disc' + index + sy_pos">
                  <a-space v-if="sy.type == 'disc'">
                    <a-tag color="blue">{{ sy.name }}:{{
                      moment(sy.stay[1])
                        .diff(moment(sy.stay[0]), "days", true)
                        .toLocaleString()
                    }}
                      Days</a-tag>
                  </a-space>
                </div>
              </template>
              <template slot="bl" slot-scope="record">
                <div style="width: 50%; text-align: center; display: inline-block">
                  B/L:
                </div>
                <div style="width: 50%; text-align: center; display: inline-block">
                  CP vs Perf.(Freight) :
                </div>

                <div style="width: 50%; text-align: center; display: inline-block">
                  <div v-if="!has_freight_quantity(record)">
                    <div v-for="(bd, bd_pos) in record.bl" :key="bd_pos">
                      <a-tag color="blue" style="display: block; margin: 5px">
                        {{ bd.date }} - {{ bd.cargo }} - {{ bd.quantity }} MT
                      </a-tag>
                    </div>
                  </div>

                  <div v-else>
                    <template v-for="(sub, sub_pos) in record.accounts.find(
                      (ac) => ac.account_name == 'Charterer'
                    ).sub_accounts">
                      <div :key="sub_pos" v-if="sub.hasOwnProperty('is_freight')">
                        <div v-for="(bd, bd_pos) in sub.breakdown" :key="bd_pos">
                          <template v-if="bd.calc_type == 'two'">
                            <a-tag color="blue" style="display: block; margin: 5px">
                              {{ bd.bl_date }} - {{ bd.item_name }} -
                              {{ bd.value_TONS }} MT
                            </a-tag>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div style="width: 50%; text-align: center; display: inline-block">
                  <div v-if="has_freight_quantity(record)">
                    <template v-for="(sub, sub_pos) in record.accounts.find(
                      (ac) => ac.account_name == 'Charterer'
                    ).sub_accounts">
                      <div :key="sub_pos" v-if="sub.hasOwnProperty('is_freight')">
                        <div v-for="(bd, bd_pos) in sub.breakdown.filter(
                          (brd) => brd.calc_type == 'two'
                        )" :key="bd_pos">
                          <a-space v-if="bd.calc_type == 'two'">
                            <a-tag :color="get_total(record, 'debit') - get_total(record, 'credit') >
                              0
                              ? 'green'
                              : 'red'
                              " style="display: block; margin: 5px">
                              ${{ bd.value_FREIGHT }}USD
                            </a-tag>
                            vs
                            <a-tag style="display: block; margin: 5px" :color="get_total(record, 'debit') - get_total(record, 'credit') >
                              0
                              ? 'green'
                              : 'red'
                              ">
                              {{
                                get_perf_freight(record, sub)[bd_pos].toLocaleString(
                                  "en-US",
                                  {
                                    style: "currency",
                                    currency: "USD",
                                  }
                                )
                              }}USD
                            </a-tag>
                          </a-space>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>

                <div>Creator:</div>
                <div style="text-align: center">
                  <a-tag color="blue" style="margin: 5px">
                    {{users.find((u) => u.id == record.creator).name.toString()}}
                  </a-tag>
                </div>
              </template>
              <template slot="pl" slot-scope="record">
                <div :style="{
                  color:
                    get_total(record, 'debit') - get_total(record, 'credit') > 0
                      ? 'green'
                      : 'red',
                  fontWeight: 'bolder',
                }">
                  {{
                    (
                      get_total(record, "debit") - get_total(record, "credit")
                    ).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })
                  }}
                </div>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="summary_old" tab="Summary(Old)">
            <a-space style="margin: 20px 0">
              <a-dropdown v-for="at in account_templates" :key="at.name">
                <a-button v-if="ui.user_id !== 5" type="primary">Add {{ at.name }}'s Template</a-button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="t in at.templates" :key="t.mv + '_' + t.charter_type + '_' + t.leg">
                    <a-button type="link" @click="
                      () => {
                        request(base_url + '/voyage_account/c', t).then((r) => {
                          if (r.data.status == 1) {
                            let d = r.data.data[0];
                            voyage_accounts.push(d);
                            console.log(d);
                            MESSAGE.success('Create Successfully');
                            voyage_accounts_opened_ids.push(d.id);
                            active_tab = d.id;
                          }
                        });
                      }
                    ">
                      Add with {{ t.mv + " " + t.charter_type + " " + t.leg }}
                    </a-button>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </a-space>
            <a-table :columns="voyage_summary_col" :data-source="voyage_accounts" rowKey="id" bordered :pagination="{
              showSizeChanger: true,
              position: 'both',
              pageSize: 50,
              pageSizeOptions: ['50', '100', '200'],
            }" :customRow="(record) => ({
              on: {
                dblclick: () => {
                  console.log(voyage_accounts_opened_ids);
                  if (voyage_accounts_opened_ids.includes(record.id)) {
                    active_tab = record.id;
                  } else {
                    active_tab = record.id;
                    voyage_accounts_opened_ids.push(record.id);
                  }
                },
              },
            })
              ">
              <div slot="filterDropdown" slot-scope="{
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  clearFilters,
                  column,
                }" style="padding: 8px">
                <a-input v-ant-ref="(c) => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block"
                  @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])" @pressEnter="
                    () => handleSearch(selectedKeys, confirm, column.dataIndex)
                  " />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"></a-icon>
              <template slot="search_filter" slot-scope="text, record, index, column">
                <span v-if="searchText && searchedColumn === column.dataIndex">
                  <template v-for="(fragment, i) in text
                    .toString()
                    .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                    <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i" class="highlight">
                      <a-space v-if="column.dataIndex == 'mv'" :key="i">
                        {{ record.mv }}
                        :
                        <a-tag color="blue">
                          {{ record.charter_type }}
                        </a-tag>
                        <a-tag color="blue">
                          {{ record.leg }}
                        </a-tag>
                      </a-space>
                      <a-tag color="blue" :key="i" v-if="column.dataIndex == 'creator'">
                        {{users.find((u) => u.id == record.creator).name.toString()}}
                      </a-tag>
                      <template v-if="column.dataIndex == 'voyage_year'">
                        {{ record.voyage_year }}
                      </template>
                      <template v-if="column.dataIndex == 'charterer'">
                        {{ record.charterer }}
                      </template>
                    </mark>
                  </template>
                </span>
                <template v-else>
                  <template v-if="column.dataIndex == 'mv'">
                    <a-space>
                      {{ record.mv }}
                      :
                      <a-tag color="blue">
                        {{ record.charter_type }}
                      </a-tag>
                      <a-tag color="blue">
                        {{ record.leg }}
                      </a-tag>
                    </a-space>
                  </template>
                  <template v-if="column.dataIndex == 'creator'">
                    <a-tag color="blue">
                      {{users.find((u) => u.id == record.creator).name.toString()}}
                    </a-tag>
                  </template>
                  <template v-if="column.dataIndex == 'voyage_year'">
                    {{ text }}
                  </template>
                  <template v-if="column.dataIndex == 'charterer'">
                    {{ record.charterer }}
                  </template>
                </template>
              </template>

              <template slot="search_cargo_filter" slot-scope="text, record">
                <div v-if="!has_freight_quantity(record)">
                  <a-tag color="blue" v-for="(bd, bd_pos) in record.bl" :key="bd_pos"
                    style="display: inline-block; margin: 5px">
                    {{ bd.date }} - {{ bd.cargo }} - {{ bd.quantity }} MT
                  </a-tag>
                  <br />
                </div>
                <div v-else>
                  <template v-for="(sub, sub_pos) in record.accounts.find(
                    (ac) => ac.account_name == 'Charterer'
                  ).sub_accounts">
                    <div :key="sub_pos" v-if="sub.hasOwnProperty('is_freight')">
                      <div v-for="(bd, bd_pos) in sub.breakdown.filter(
                        (brd) => brd.calc_type == 'two'
                      )" :key="bd_pos">
                        <a-space v-if="bd.calc_type == 'two'">
                          <a-tag color="blue">{{ bd.bl_date }}</a-tag>
                          <a-tag color="blue">{{ bd.item_name }}</a-tag>
                          <a-tag color="blue">{{ bd.value_TONS }} MT</a-tag>
                          /
                          <a-tag :color="get_total(record, 'debit') - get_total(record, 'credit') > 0
                            ? 'green'
                            : 'red'
                            " style="display: block; margin: 5px">
                            ${{ bd.value_FREIGHT }}
                          </a-tag>
                          vs
                          <a-tag style="display: block; margin: 5px" :color="get_total(record, 'debit') - get_total(record, 'credit') > 0
                            ? 'green'
                            : 'red'
                            ">
                            {{
                              get_perf_freight(record, sub)[bd_pos].toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "USD",
                                }
                              )
                            }}
                          </a-tag>
                        </a-space>
                      </div>
                    </div>
                  </template>
                </div>
              </template>

              <template slot="bl" slot-scope="record">
                <div v-if="!has_freight_quantity(record)">
                  <a-space>
                    <a-tag color="blue" v-for="(bd, bd_pos) in record.bl" :key="bd_pos"
                      style="display: block; margin: 5px">
                      {{ bd.date }} - {{ bd.cargo }} - {{ bd.quantity }} MT
                    </a-tag>
                  </a-space>
                </div>
                <div v-else>
                  <template v-for="(sub, sub_pos) in record.accounts.find(
                    (ac) => ac.account_name == 'Charterer'
                  ).sub_accounts">
                    <div :key="sub_pos" v-if="sub.hasOwnProperty('is_freight')">
                      <div v-for="(bd, bd_pos) in sub.breakdown.filter(
                        (brd) => brd.calc_type == 'two'
                      )" :key="bd_pos">
                        <a-space>
                          <a-tag color="blue">{{ bd.bl_date }}</a-tag>
                          <a-tag color="blue">{{ bd.item_name }}</a-tag>
                          <a-tag color="blue">{{ bd.value_TONS }} MT</a-tag>
                          /
                          <a-tag :color="get_total(record, 'debit') - get_total(record, 'credit') > 0
                            ? 'green'
                            : 'red'
                            " style="display: block; margin: 5px">
                            ${{ bd.value_FREIGHT }}
                          </a-tag>
                          vs
                          <a-tag style="display: block; margin: 5px" :color="get_total(record, 'debit') - get_total(record, 'credit') > 0
                            ? 'green'
                            : 'red'
                            ">
                            {{
                              get_perf_freight(record, sub)[bd_pos].toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "USD",
                                }
                              )
                            }}
                          </a-tag>
                        </a-space>
                      </div>
                    </div>
                  </template>
                </div>
              </template>

              <template slot="laycan" slot-scope="record">
                {{ record.laycan[0] }} ~ {{ record.laycan[1] }}
              </template>
              <template slot="load_disc_port" slot-scope="record, index">
                {{ record.load_port }} ~ {{ record.disc_port }}
                <a-divider></a-divider>
                <div v-for="(sy, sy_pos) in record.port_stay" :key="'summary_port_stay_load' + index + sy_pos">
                  <a-space v-if="sy.type == 'load'">
                    <a-tag color="blue">{{ sy.name }}:{{
                      moment(sy.stay[1])
                        .diff(moment(sy.stay[0]), "days", true)
                        .toLocaleString()
                    }}
                      Days</a-tag>
                  </a-space>
                </div>
                <div v-for="(sy, sy_pos) in record.port_stay" :key="'summary_port_stay_disc' + index + sy_pos">
                  <a-space v-if="sy.type == 'disc'">
                    <a-tag color="blue">{{ sy.name }}:{{
                      moment(sy.stay[1])
                        .diff(moment(sy.stay[0]), "days", true)
                        .toLocaleString()
                    }}
                      Days</a-tag>
                  </a-space>
                </div>
              </template>

              <template slot="pl" slot-scope="record">
                <div :style="{
                  color:
                    get_total(record, 'debit') - get_total(record, 'credit') > 0
                      ? 'green'
                      : 'red',
                  fontWeight: 'bolder',
                }">
                  {{
                    (
                      get_total(record, "debit") - get_total(record, "credit")
                    ).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })
                  }}
                </div>
                <a-space>
                  <a-button v-if="ui.user_id !== 5" size="small" type="primary" @click="
                    () => {
                      request(
                        base_url + '/voyage_account/c',
                        sanitize_account(record)
                      ).then((r) => {
                        if (r.data.status == 1) {
                          MESSAGE.success('Create Successfully');
                          voyage_accounts.push(r.data.data[0]);
                          voyage_accounts_opened_ids.push(r.data.data[0].id);
                          active_tab = r.data.data[0].id;
                        }
                      });
                    }
                  ">
                    Create From ...</a-button>
                  <a-popconfirm v-if="ui.user_id !== 5" title="Are you sure delete this record?" ok-text="OK"
                    cancel-text="Cancel" @confirm="
                      () => {
                        if (ui.user_id !== 1 && ui.user_id !== record.creator) {
                          MESSAGE.error('You are not allowed to delete this record');
                          return;
                        }
                        request(base_url + '/voyage_account/d', {
                          id: record.id,
                        }).then((r) => {
                          if (r.data.status == 1) {
                            MESSAGE.success('Del Successfully');
                            let pos = voyage_accounts.findIndex((v) => v.id == record.id);
                            voyage_accounts.splice(pos, 1);
                          }
                        });
                      }
                    ">
                    <a-button v-if="ui.user_id !== 5" size="small" type="danger">
                      Del
                    </a-button>
                  </a-popconfirm>
                </a-space>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="pivot" tab="Pivot Table">
            <a-form layout="inline">
              <a-form-item label="Voyage Year">
                <a-select style="width: 200px" v-model="pivot_table_settings.voyage_year">
                  <a-select-option :value="'all'"> ALL </a-select-option>
                  <a-select-option v-for="n in moment().year() - 2020 + 3" :key="n + 2020" :value="n + 2020">{{ n + 2020
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Row By">
                <a-select style="width: 200px" v-model="pivot_table_settings.row_by">
                  <a-select-option value="charterer"
                    :disabled="pivot_table_settings.column_by == 'charterer'">Charterer</a-select-option>
                  <a-select-option value="cargo"
                    :disabled="pivot_table_settings.column_by == 'cargo'">Cargo</a-select-option>
                  <a-select-option value="bl" :disabled="pivot_table_settings.column_by == 'bl'">BL By
                    Month</a-select-option>
                  <a-select-option value="bl_yr" :disabled="pivot_table_settings.column_by == 'bl_yr'">BL By
                    year</a-select-option>
                  <a-select-option value="creator"
                    :disabled="pivot_table_settings.column_by == 'creator'">Creator</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Column By">
                <a-select style="width: 200px" v-model="pivot_table_settings.column_by">
                  <a-select-option value="charterer"
                    :disabled="pivot_table_settings.row_by == 'charterer'">Charterer</a-select-option>
                  <a-select-option value="cargo"
                    :disabled="pivot_table_settings.row_by == 'cargo'">Cargo</a-select-option>
                  <a-select-option value="bl" :disabled="pivot_table_settings.row_by == 'bl'">BL by
                    Month</a-select-option>
                  <a-select-option value="bl_yr" :disabled="pivot_table_settings.row_by == 'bl_yr'">BL by
                    Year</a-select-option>
                  <a-select-option value="creator"
                    :disabled="pivot_table_settings.row_by == 'creator'">Creator</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Result As">
                <a-select style="width: 200px" v-model="pivot_table_settings.result_as">
                  <a-select-option value="quantity">Quantity</a-select-option>
                  <a-select-option value="pl">P&L</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-space>
                  <a-button type="primary" @click="
                    () => {
                      if (pivot_table_settings.voyage_year == 'all') {
                        let year_arr = get_unduplicate_array_by_prop(
                          voyage_accounts,
                          'voyage_year'
                        );
                        voyage_granularized_info_by_year = year_arr.map((y) => {
                          return {
                            year: y,
                            data: get_granularized_vessel_info(
                              voyage_accounts.filter((v) => v.voyage_year == y)
                            ),
                          };
                        });
                      } else {
                        voyage_granularized_info_by_year = [
                          {
                            year: pivot_table_settings.voyage_year,
                            data: get_granularized_vessel_info(
                              voyage_accounts.filter(
                                (v) => v.voyage_year == pivot_table_settings.voyage_year
                              )
                            ),
                          },
                        ];
                      }
                      console.log(voyage_granularized_info_by_year);
                      voyage_granularized_info = get_granularized_vessel_info(
                        voyage_accounts.filter(
                          (v) =>
                            pivot_table_settings.voyage_year == 'all' ||
                            v.voyage_year == pivot_table_settings.voyage_year
                        )
                      );
                      console.log(voyage_granularized_info);
                      pivot_rows = get_unduplicate_array_by_prop(
                        voyage_accounts,
                        pivot_table_settings.row_by
                      );
                      pivot_cols = get_unduplicate_array_by_prop(
                        voyage_accounts,
                        pivot_table_settings.column_by
                      );
                    }
                  ">
                    Generate
                  </a-button>
                </a-space>
              </a-form-item>
            </a-form>

            <div style="display: flex">
              <div style="vertical-align: top; display: inline-block">
                <table style="
                    vertical-align: top;
                    margin-top: 30px;
                    text-align: center;
                    font-weight: bold;
                  " border="3">
                  <tr style="height: 100px">
                    <td colspan="2">
                      {{ pivot_table_settings.row_by }}
                      <br />
                      vs
                      <br />
                      {{ pivot_table_settings.column_by }}
                    </td>
                  </tr>
                  <template v-for="y in voyage_granularized_info_by_year">
                    <template>
                      <tr v-for="(r, r_pos) in pivot_rows" :key="y.year + '_' + r_pos">
                        <td v-if="r_pos == 0" :rowspan="pivot_rows.length" style="border-right: 3px">
                          {{ y.year }}
                        </td>
                        <td class="col_height" style="
                            text-align: right;
                            white-space: nowrap;
                            border-top: none;
                            height: 24px;
                          ">
                          {{ r }}
                        </td>
                      </tr>
                    </template>
                  </template>
                  <tr>
                    <td colspan="2">Total:</td>
                  </tr>
                </table>
              </div>

              <div style="vertical-align: top; display: inline-block; overflow-y: scroll">
                <table style="
                    width: calc(100% - 200px);
                    margin-top: 30px;
                    text-align: center;
                    font-weight: bold;
                    border-left: none;
                  " border="3">
                  <tr style="height: 100px">
                    <td v-for="c in pivot_cols" :key="c" style="min-width: 100px">
                      {{ c }}
                    </td>
                    <td>TOTAL</td>
                  </tr>
                  <template v-for="y in voyage_granularized_info_by_year">
                    <template>
                      <tr v-for="r in pivot_rows" :key="y.year + '_' + r">
                        <td v-for="c in pivot_cols" :key="c" style="font-weight: lighter">
                          {{
                            pivot_table_settings.result_as == "quantity"
                              ? two_dimen_calc(
                                y.data,
                                pivot_table_settings.row_by,
                                r,
                                pivot_table_settings.column_by,
                                c,
                                pivot_table_settings.result_as
                              ).toLocaleString("en-US")
                              : two_dimen_calc(
                                y.data,
                                pivot_table_settings.row_by,
                                r,
                                pivot_table_settings.column_by,
                                c,
                                pivot_table_settings.result_as
                              ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                          }}
                        </td>
                        <td style="border-bottom: none; border-top: none">
                          {{
                            pivot_table_settings.result_as == "quantity"
                              ? one_dimen_calc(
                                y.data,
                                pivot_table_settings.row_by,
                                r,
                                pivot_table_settings.result_as
                              ).toLocaleString("en-US")
                              : one_dimen_calc(
                                y.data,
                                pivot_table_settings.row_by,
                                r,
                                pivot_table_settings.result_as
                              ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                          }}
                        </td>
                      </tr>
                    </template>
                  </template>
                  <tr>
                    <td v-for="c in pivot_cols" :key="c" style="font-weight: lighter">
                      {{
                        pivot_table_settings.result_as == "quantity"
                          ? one_dimen_calc(
                            voyage_granularized_info,
                            pivot_table_settings.column_by,
                            c,
                            pivot_table_settings.result_as
                          ).toLocaleString("en-US")
                          : one_dimen_calc(
                            voyage_granularized_info,
                            pivot_table_settings.column_by,
                            c,
                            pivot_table_settings.result_as
                          ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })
                      }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane>
      <a-tab-pane style="position: relative" v-for="vy_pos in voyage_accounts_opened_pos"
        :key="voyage_accounts[vy_pos].id" :tab="'ID:' + voyage_accounts[vy_pos].id + '/' + voyage_accounts[vy_pos].mv"
        class="voyage_tab">
        <div v-if="ui.user_id == 5" style="
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #3333;
            z-index: 99;
          "></div>
        <a-divider>
          Voyage Infomation / {{ "ID:" + voyage_accounts[vy_pos].id }}
        </a-divider>
        <a-descriptions title="Base Info" bordered>
          <a-descriptions-item label="M.V." :span="1">
            <a-input v-model="voyage_accounts[vy_pos].mv"></a-input>
          </a-descriptions-item>
          <a-descriptions-item label="Charter Mode" :span="1">
            <a-input v-model="voyage_accounts[vy_pos].charter_type" style="display: inline-block; width: 50%"
              placeholder="Type"></a-input>
            <a-input v-model="voyage_accounts[vy_pos].leg" style="display: inline-block; width: 35%; margin-left: 20px"
              placeholder="# of Leg(if Applicable)"></a-input>
          </a-descriptions-item>
          <a-descriptions-item label="Voyage Year" :span="1">
            <a-input type="number" step="1" v-model="voyage_accounts[vy_pos].voyage_year"></a-input>
          </a-descriptions-item>
          <a-descriptions-item label="Delivery ~ Redelivery" :span="1">
            <a-input-group compact>
              <a-input style="width: 38%; text-align: center; border-right: 0" placeholder="Delivery"
                v-model="voyage_accounts[vy_pos].delivery" />
              <a-input style="
                  width: 10%;
                  border-left: 0;
                  border-right: 0;
                  pointer-events: none;
                  background-color: #fff;
                  text-align: center;
                " placeholder="~" disabled />
              <a-input style="width: 38%; text-align: center; border-left: 0" placeholder="Redivery"
                v-model="voyage_accounts[vy_pos].redelivery" />
            </a-input-group>
          </a-descriptions-item>
          <a-descriptions-item label="Load Port ~ Disch. Port" :span="1">
            <a-input-group compact>
              <a-input style="width: 38%; text-align: center" placeholder="Delivery"
                v-model="voyage_accounts[vy_pos].load_port" />
              <a-input style="
                  width: 60px;
                  border-left: 0;
                  pointer-events: none;
                  background-color: #fff;
                  text-align: center;
                " placeholder="~" disabled />
              <a-input style="width: 38%; text-align: center; border-left: 0" placeholder="Redivery"
                v-model="voyage_accounts[vy_pos].disc_port" />
            </a-input-group>
          </a-descriptions-item>
          <a-descriptions-item label="Lay Time ~ Cancel Time" :span="1">
            <a-input-group compact>
              <a-input style="width: 38%; text-align: center" placeholder="Delivery"
                v-model="voyage_accounts[vy_pos].laycan[0]" />
              <a-input style="
                  width: 60px;
                  border-left: 0;
                  pointer-events: none;
                  background-color: #fff;
                  text-align: center;
                " placeholder="~" disabled />
              <a-input style="width: 38%; text-align: center; border-left: 0" placeholder="Redivery"
                v-model="voyage_accounts[vy_pos].laycan[1]" />
            </a-input-group>
          </a-descriptions-item>
          <a-descriptions-item label="Charterer" :span="1">
            <a-input v-model="voyage_accounts[vy_pos].charterer"></a-input>
          </a-descriptions-item>
          <a-descriptions-item label="Port Stay" :span="1">
            <a-popconfirm ok-text="Add" cancel-text="Cancel" @confirm="
              () => {
                voyage_accounts[vy_pos].port_stay.push({
                  type: temp_port_stay.type,
                  name: temp_port_stay.name,
                  stay: temp_port_stay.stay,
                });
                temp_port_stay = { type: '', name: '', stay: ['', ''] };
              }
            " @cancel="
              () => {
                temp_port_stay = { type: '', name: '', stay: ['', ''] };
              }
            ">
              <template slot="title">
                <p>Please Fill in the Port Stay Info</p>
                <a-space>
                  <a-select placeholder="L/D" size="small" style="width: 100px" v-model="temp_port_stay.type">
                    <a-select-option value="load">Load</a-select-option>
                    <a-select-option value="disc">Disc</a-select-option>
                  </a-select>
                  <a-input placeholder="Port" size="small" v-model="temp_port_stay.name">
                  </a-input>
                  <a-input-group compact size="small">
                    <a-input style="width: 38%; text-align: center" placeholder="From"
                      v-model="temp_port_stay.stay[0]" />
                    <a-input style="
                        width: 60px;
                        border-left: 0;
                        pointer-events: none;
                        background-color: #fff;
                        text-align: center;
                      " placeholder="~" disabled />
                    <a-input style="width: 38%; text-align: center; border-left: 0" placeholder="To"
                      v-model="temp_port_stay.stay[1]" />
                  </a-input-group>
                </a-space>
              </template>

              <a-button type="primary" size="small" v-if="ui.user_id !== 5">ADD</a-button>
            </a-popconfirm>
            <a-divider />

            <div v-for="(sy, sy_pos) in voyage_accounts[vy_pos].port_stay" :key="sy_pos" style="margin:5px;auto">
              <a-space>
                <a-tag color="blue">
                  {{ sy.type.toUpperCase() }}
                </a-tag>
                :
                <a-tag color="blue">
                  {{ sy.name }} -
                  {{ moment(sy.stay[1]).diff(moment(sy.stay[0]), "days") }}days
                </a-tag>
                <a-button v-if="ui.user_id !== 5" type="danger" size="small" @click="
                  () => {
                    voyage_accounts[vy_pos].port_stay.splice(sy_pos, 1);
                  }
                ">
                  Del
                </a-button>
              </a-space>
            </div>
          </a-descriptions-item>

          <a-descriptions-item label="B/L Date Cargo and Quantity" :span="1" v-if="
            voyage_accounts[vy_pos].accounts[1].sub_accounts.every(
              (sa) => !sa.hasOwnProperty('is_freight')
            )
          ">
            <h3>
              This part will be ignored if Charterer is VC type i.e. inputing freight info
              in Charterer's Account
            </h3>
            <br />
            <a-space v-for="(bl, bl_pos) in voyage_accounts[vy_pos].bl" :key="bl_pos">
              <a-date-picker v-model="bl.date" valueFormat="YYYY/MM/DD" format="YYYY/MM/DD" />
              <a-auto-complete v-model="bl.cargo" :data-source="suggest_cargo" placeholder="Cargo" @search="
                (e) => {
                  suggest_cargo = !e
                    ? []
                    : available_cargo.filter((v) =>
                      v.toLowerCase().includes(e.toLowerCase())
                    );
                  console.log(suggest_cargo);
                }
              " />

              <a-input v-model="bl.quantity" type="number"></a-input>
              <a-button v-if="ui.user_id !== 5" type="danger" @click="
                () => {
                  voyage_accounts[vy_pos].bl.splice(bl_pos, 1);
                }
              ">
                Del
              </a-button>
            </a-space>
            <br />
            <a-button v-if="ui.user_id !== 5" type="primary" @click="
              () => {
                voyage_accounts[vy_pos].bl.push({
                  date: moment().format('YYYY/MM/DD'),
                  cargo: '',
                  quantity: 0,
                });
              }
            ">
              ADD
            </a-button>
          </a-descriptions-item>
        </a-descriptions>
        <template v-if="ui.user_id !== 5">
          <div class="float_menu" v-if="show_float_menu">
            <a-tabs>
              <a-tab-pane :tab="ac.account_name" v-for="(ac, ac_pos) in voyage_accounts[vy_pos].accounts"
                :key="'button_tab_' + ac_pos">
                <a-button type="primary" v-for="k in Object.keys(
                  get_item_template(ac.account_name.toLowerCase())
                )" :key="k" @click="
                  () => {
                    if (k == 'freight') {
                      voyage_accounts[vy_pos].bl = [];
                    }
                    ac.sub_accounts.push({
                      ...get_item_template(ac.account_name.toLowerCase())[k],
                    });
                    show_float_menu = false;
                  }
                ">
                  Add {{ k.toUpperCase() }}
                </a-button>
                <a-button type="primary" size="large" style="width: 200px; display: block; margin: 50px auto" @click="
                  () => {
                    VoyageExportExcel(voyage_accounts[vy_pos]);
                    show_float_menu = false;
                  }
                ">Export to Excel
                </a-button>
                <a-button type="primary" size="large" style="width: 200px; display: block; margin: 50px auto" @click="
                  () => {
                    request(
                      base_url + '/voyage_account/u',
                      voyage_accounts[vy_pos]
                    ).then((r) => {
                      if (r.data.status == 1) {
                        MESSAGE.success('Saved Successfully');
                        show_float_menu = false;
                      }
                    });
                  }
                ">Save
                </a-button>
                <a-button type="danger" size="large" style="width: 200px; display: block; margin: 50px auto" @click="
                  () => {
                    show_float_menu = false;
                  }
                ">Close</a-button>
              </a-tab-pane>
            </a-tabs>
          </div>
          <a-button v-else class="float_button" type="primary" size="large" shape="circle" icon="ordered-list" @click="
            () => {
              show_float_menu = true;
            }
          ">
          </a-button>
        </template>
        <a-tabs default-active-key="accounts_0">
          <a-tab-pane v-for="(ac, ac_pos) in voyage_accounts[vy_pos].accounts" :tab="ac.account_name"
            :key="'accounts_' + ac_pos">
            <a-divider orientation="left">
              {{ ac_pos + 1 }}. {{ ac.account_name }}
            </a-divider>
            <div v-for="(sub, sub_pos) in ac.sub_accounts" :key="'sub_accounts_' + ac_pos + '_' + sub_pos"
              class="accout_wrapper">
              <a-row :gutter="[16, 16]">
                <a-col :span="12" style="font-weight: bolder">
                  <a-space>
                    {{ sub_pos + 1 }}.
                    <a-input v-model="sub.sub_account_name" style="width: 500px; font-weight: bolder"></a-input>

                    <a-input-group v-if="ac_pos == 1" compact style="width: 300px" @click="
                      () => {
                        if (sub.hasOwnProperty('is_freight')) {
                          console.log('here');
                          delete_is_freight(sub);
                        } else {
                          add_is_freight(sub);
                        }
                      }
                    ">
                      <a-button :type="sub.hasOwnProperty('is_freight') ? 'primary' : ''">Is A Freight Item</a-button>
                      <a-button :type="sub.hasOwnProperty('is_freight') ? '' : 'primary'">Not A Freight Item</a-button>
                    </a-input-group>

                    <a-popconfirm ok-text="Yes" cancel-text="No" @confirm="
                      () => {
                        ac.sub_accounts.splice(sub_pos, 1);
                      }
                    ">
                      <template slot="title">
                        <p>Are you sure to Del this ACCOUNT?</p>
                      </template>
                      <a-button type="danger" style="margin-left: 30px" v-if="ui.user_id !== 5">
                        DEL
                      </a-button>
                    </a-popconfirm>
                    <!-- {{ sub }} -->
                  </a-space>
                </a-col>
                <a-col :span="3"></a-col>
                <a-col :span="2" style="font-weight: bolder; text-align: center">Debit</a-col>
                <a-col :span="2" style="font-weight: bolder; text-align: center">Credit</a-col>
                <a-col :span="5" style="font-weight: bolder; text-align: center">Ops</a-col>
              </a-row>
              <a-divider>
                <!-- {{ sub.hasOwnProperty("is_freight") }} -->
              </a-divider>
              <a-row :gutter="[16, 16]" v-for="(bd, bd_pos) in sub.breakdown"
                :key="'breakdown_' + ac_pos + '_' + sub_pos + '_' + bd_pos">
                <a-col :span="3"></a-col>
                <template v-if="bd.calc_type == 'period'">
                  <a-col :span="3"> Start Time </a-col>
                  <a-col :span="3"> End Time </a-col>
                  <a-col :span="3"> Days </a-col>
                  <a-col :span="3">{{
                    get_keys_start_with(bd, "value")[0].slice(6)
                  }}</a-col>
                </template>
                <template v-else-if="bd.calc_type == 'percentage'">
                  <a-col :span="9">-</a-col>
                  <a-col :span="3">{{
                    get_keys_start_with(bd, "value")[0].slice(6)
                  }}</a-col>
                </template>
                <template v-else>
                  <a-col :span="3" v-for="n in 4 - count_keys_start_with(bd, 'value')" :key="'breakdown_title_blank_' +
                    ac_pos +
                    '_' +
                    sub_pos +
                    '_' +
                    bd_pos +
                    '_' +
                    n
                    ">
                  </a-col>
                  <a-col :span="3" v-for="k in get_keys_start_with(bd, 'value')" :key="'breakdown_title_' + ac_pos + '_' + sub_pos + '_' + bd_pos + '_' + k
                    ">{{ k.slice(6) }}</a-col>
                </template>
                <a-col :span="2">-</a-col>
                <a-col :span="2">-</a-col>
                <a-col :span="5" style="text-align: center">
                  <a-space>
                    <a-radio-group size="small" button-style="solid" v-model="bd.is_settled">
                      <a-radio-button :value="true"> Settled </a-radio-button>
                      <a-radio-button :value="false"> UnSettled </a-radio-button>
                    </a-radio-group>
                    <a-button type="primary" size="small" :disabled="bd.is_settled" @click="
                      () => {
                        sub.breakdown.splice(bd_pos - 1, 0, bd);
                        sub.breakdown.splice(bd_pos + 1, 1);
                      }
                    " v-if="bd_pos !== 0">
                      <a-icon type="arrow-up" />
                    </a-button>
                  </a-space>
                </a-col>
                <a-col :span="3">
                  <div v-if="sub.hasOwnProperty('is_freight') && bd.calc_type == 'two'" style="color: red">
                    <!-- <a-input
                      size="small"
                      v-model="bd.item_name"
                      style="width: 100%"
                      :disabled="bd.is_settled"
                    ></a-input> -->

                    <a-auto-complete size="small" v-model="bd.item_name" :data-source="suggest_cargo"
                      style="width: 100%" placeholder="Cargo" @search="
                        (e) => {
                          suggest_cargo = !e
                            ? []
                            : available_cargo.filter((v) =>
                              v.toLowerCase().includes(e.toLowerCase())
                            );
                          console.log(suggest_cargo);
                        }
                      " />

                    <a-date-picker v-model="bd.bl_date" size="small" valueFormat="YYYY/MM/DD"
                      style="width: 100%; margin-right: 10px; margin-top: 10px" format=" YYYY/MM/DD"
                      :disabled="bd.is_settled">
                    </a-date-picker>
                    <br />
                    Please Fill in CARGO NAME and BL Date so as to Perform Pivot Table
                    Calculation
                  </div>
                  <a-input size="small" v-model="bd.item_name" style="width: 100%" :disabled="bd.is_settled"
                    v-else></a-input>
                </a-col>
                <template v-if="bd.calc_type == 'period'">
                  <a-col :span="6">
                    <a-input-group compact>
                      <a-input size="small" style="width: 38%; text-align: center" :disabled="bd.is_settled"
                        placeholder=" FROM" v-model="bd.period[0]" />
                      <a-input size="small" style="
                          width: 20px;
                          border-left: 0;
                          pointer-events: none;
                          background-color: #fff;
                          text-align: center;
                        " placeholder="~" disabled />
                      <a-input size="small" style="width: 38%; text-align: center; border-left: 0"
                        :disabled="bd.is_settled" placeholder="TO" v-model="bd.period[1]" />
                    </a-input-group>
                  </a-col>
                  <a-col :span="3">
                    {{
                      bd.period
                        ? moment(bd.period[1])
                          .diff(moment(bd.period[0]), "days", true)
                          .toLocaleString()
                        : ""
                    }}
                  </a-col>
                  <a-col :span="3">
                    <a-input size="small" v-model="bd[get_keys_start_with(bd, 'value')[0]]" style="width: 60%"
                      :disabled="bd.is_settled" type="number"></a-input>
                  </a-col>
                </template>
                <template v-else-if="bd.calc_type == 'percentage'">
                  <a-col :span="9"></a-col>
                  <a-col :span="3">
                    <a-input size="small" v-model="bd[get_keys_start_with(bd, 'value')[0]]" style="width: 60%"
                      :disabled="bd.is_settled" type="number" step="0.01" suffix="%"></a-input></a-col>
                </template>
                <template v-else>
                  <a-col :span="3" v-for="n in 4 - count_keys_start_with(bd, 'value')" :key="'breakdown_content_blank_' +
                    ac_pos +
                    '_' +
                    sub_pos +
                    '_' +
                    bd_pos +
                    '_' +
                    n
                    ">
                  </a-col>
                  <a-col :span="3" v-for="k in get_keys_start_with(bd, 'value')" :key="'breakdown_content_' +
                    ac_pos +
                    '_' +
                    sub_pos +
                    '_' +
                    bd_pos +
                    '_' +
                    k
                    ">
                    <a-input size="small" v-model="bd[k]" style="width: 60%" :disabled="bd.is_settled"
                      type="number"></a-input>
                  </a-col>
                </template>
                <a-col :span="2" v-if="bd.debit_credit == 'debit'" :style="{
                  color: bd.is_settled ? '#000' : 'red',
                  textAlign: 'right',
                }">
                  {{
                    multipy_keys_start_with(sub.breakdown, bd, "value").toLocaleString(
                      "en-US",
                      {
                        style: "currency",
                        currency: "USD",
                      }
                    )
                  }}
                </a-col>
                <a-col :span="2" v-else>-</a-col>
                <a-col :span="2" v-if="bd.debit_credit == 'credit'" :style="{
                  color: bd.is_settled ? '#000' : 'red',
                  textAlign: 'right',
                }">
                  {{
                    multipy_keys_start_with(sub.breakdown, bd, "value").toLocaleString(
                      "en-US",
                      {
                        style: "currency",
                        currency: "USD",
                      }
                    )
                  }}
                </a-col>
                <a-col :span="2" v-else>-</a-col>
                <a-col :span="5" style="text-align: center">
                  <a-space>
                    <a-radio-group size="small" button-style="solid" v-model="bd.debit_credit"
                      :disabled="bd.is_settled">
                      <a-radio-button :value="'debit'"> Debit </a-radio-button>
                      <a-radio-button :value="'credit'"> Credit </a-radio-button>
                    </a-radio-group>
                    <a-popconfirm ok-text="Yes" cancel-text="No" @confirm="
                      () => {
                        sub.breakdown.splice(bd_pos, 1);
                      }
                    ">
                      <template slot="title">
                        <p>Are you Sure to Del this ITEM?</p>
                      </template>
                      <a-button v-if="ui.user_id !== 5" type="danger" size="small">
                        DEL
                      </a-button>
                    </a-popconfirm>
                  </a-space>
                </a-col>
              </a-row>
              <a-button v-if="ui.user_id !== 5" type="primary" style="width: 80%; margin: 20px 10%" @click="
                () => {
                  add_subaccout_item_visible = true;
                  selected_account_pos = ac_pos;
                  selected_subaccount_pos = sub_pos;
                }
              ">Add <a-icon type="table" /></a-button>
              <a-divider></a-divider>
              <a-row :gutter="[16, 16]">
                <template v-if="if_period_based_item_exist(sub.breakdown)">
                  <a-col :span="6">-</a-col>
                  <a-col :span="3" style="font-weight: bolder">Sum of Period</a-col>
                  <a-col :span="3">{{
                    total_perid_in_days(sub.breakdown).toLocaleString()
                  }}</a-col>
                </template>
                <template v-else>
                  <a-col :span="12"></a-col>
                </template>
                <a-col :span="3" style="font-weight: bolder"> Subtotal </a-col>
                <a-col :span="2" style="font-weight: bolder; text-align: right">
                  {{
                    sum_breakdown(sub.breakdown, "value", "debit").toLocaleString(
                      "en-US",
                      {
                        style: "currency",
                        currency: "USD",
                      }
                    )
                  }}
                </a-col>
                <a-col :span="2" style="font-weight: bolder; text-align: right">
                  {{
                    sum_breakdown(sub.breakdown, "value", "credit").toLocaleString(
                      "en-US",
                      {
                        style: "currency",
                        currency: "USD",
                      }
                    )
                  }}
                </a-col>
                <a-col :span="2" style="font-weight: bolder; text-align: center">=</a-col>
                <a-col :span="3" style="font-weight: bolder">
                  {{
                    (
                      sum_breakdown(sub.breakdown, "value", "debit") -
                      sum_breakdown(sub.breakdown, "value", "credit")
                    ).toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })
                  }}</a-col>
              </a-row>
            </div>
          </a-tab-pane>
        </a-tabs>
        <div>
          <a-divider></a-divider>
          <a-row :gutter="[16, 16]">
            <a-col :span="12"></a-col>
            <a-col :span="3" style="font-weight: bolder">
              <h2>TOTAL</h2>
            </a-col>
            <a-col :span="2" style="font-weight: bolder">
              <h2>
                {{
                  get_total(voyage_accounts[vy_pos], "debit").toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                }}
              </h2>
            </a-col>
            <a-col :span="2" style="font-weight: bolder">
              <h2>
                {{
                  get_total(voyage_accounts[vy_pos], "credit").toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                }}
              </h2>
            </a-col>
            <a-col :span="2">
              <h2>=</h2>
            </a-col>
            <a-col :span="3">
              <h2>
                {{
                  (
                    get_total(voyage_accounts[vy_pos], "debit") -
                    get_total(voyage_accounts[vy_pos], "credit")
                  ).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                }}
              </h2>
            </a-col>
          </a-row>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import Vue from "vue";
import * as XLSX from "xlsx";
import vessel_account_item from "./vessel_account_item";
import account_templates from "./account_templates.js";
import moment from "moment";
import userinfo from "../../utils/userinfo.js";

import voyage_summary_col from "./voyage_summary_col";
import account_by_vessel_utils from "./account_by_vessel_utils.js";
import account_by_month_utils from "./account_by_month_utils.js";
import { summary_to_excel } from "./summary_to_excel";

import summary_table_pagination from "./summary_table_pagination";

import VoyageExportExcel from "./voyage_export_excel";
import {
  get_unduplicate_array_by_prop,
  get_granularized_vessel_info,
  two_dimen_calc,
  one_dimen_calc,
} from "./pivot_table_utils";
// import voyage_account_sample from "./voyage_account_sample";
import users from "./users";

import {
  count_keys_start_with,
  get_keys_start_with,
  multipy_keys_start_with,
  sum_breakdown,
  get_item_template,
  if_period_based_item_exist,
  total_perid_in_days,
  has_freight_quantity,
  get_freight_quantity,
  get_total,
  get_perf_freight,
  get_unsettled_total,
  sanitize_account,
} from "./voyage_account_util";

export default {
  name: "voyage_pl",
  data() {
    return {
      //base utils
      request: this.$http.post,
      base_url: this.$store.state.base_url,
      template: vessel_account_item,
      account_templates,
      users,
      ui: userinfo.get(),
      moment,
      console,
      Vue,
      XLSX,

      MESSAGE: this.$message,

      voyage_accounts: [],
      active_tab: "summary",
      voyage_accounts_opened_ids: [],
      voyage_accounts_opened_pos: [],
      available_cargo: [],
      suggest_cargo: [],

      // old summary table
      voyage_summary_col,
      searchText: "",
      searchInput: null,
      searchedColumn: "",

      // new summary table
      summary_data: [],
      summary_cols: [],
      summary_paginations: {},
      account_by_vessel_utils,
      account_by_month_utils,
      summary_table_pagination,
      type_of_summary: "month",

      // account detail page
      add_subaccout_item_visible: false,
      selected_account_pos: 0,
      selected_subaccount_pos: 0,
      show_float_menu: false,
      temp_time_for_split: "",
      multi_period_items: {
        total_period: [],
        first_time_node: "",
        duration: 1,
      },
      time_node: [],
      new_item: {
        item_name: "",
        is_settled: false,
        calc_type: "one",
        debit_credit: "debit",
        props: [""],
      },
      temp_port_stay: {
        type: "load",
        name: "",
        stay: ["", ""],
      },

      //pivot table settings
      pivot_table_settings: {
        voyage_year: "all",
        row_by: "cargo",
        column_by: "charterer",
        result_as: "quantity",
      },
      voyage_granularized_info: [],
      voyage_granularized_info_by_year: [],
      pivot_rows: [],
      pivot_cols: [],
    };
  },
  mounted() {
    this.$http.post(this.$store.state.base_url + "/voyage_account/r", {}).then((res) => {
      if (res.data.status == 1) {
        this.available_cargo = get_unduplicate_array_by_prop(res.data.data, "cargo");
        this.voyage_accounts = res.data.data;
        // if (this.ui.user_id == 1 || this.ui.user_id == 20 || this.ui.user_id == 5) {
        //   this.voyage_accounts = res.data.data;
        // }
        // if (this.ui.user_id == 19) {
        //   this.voyage_accounts = res.data.data.filter(
        //     (r) => r.creator == this.ui.user_id || r.creator == 24
        //   );
        // }
      }
    });
  },

  methods: {
    summary_to_excel,
    get_unduplicate_array_by_prop,
    two_dimen_calc,
    one_dimen_calc,
    get_granularized_vessel_info,
    count_keys_start_with,
    get_keys_start_with,
    multipy_keys_start_with,
    sum_breakdown,
    get_item_template,
    if_period_based_item_exist,
    total_perid_in_days,
    has_freight_quantity,
    get_freight_quantity,
    get_total,
    get_perf_freight,
    get_unsettled_total,
    VoyageExportExcel,
    sanitize_account,
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    delete_is_freight(sub) {
      Vue.delete(sub, "is_freight");
    },
    add_is_freight(sub) {
      Vue.set(sub, "is_freight", "");
    },
  },
  watch: {
    multi_period_items: {
      deep: true,
      handler: function (n, o) {
        if (
          n.total_period.length == 2 &&
          n.first_time_node !== "" &&
          parseFloat(n.duration) > 3 &&
          new moment(n.total_period[1]).diff(new moment(n.first_time_node)) > 0 &&
          new moment(n.first_time_node).diff(new moment(n.total_period[0])) > 0
        ) {
          this.time_node = [];
          this.time_node.push(
            new moment(n.total_period[0]).clone().format("YYYY/MM/DD HH:mm")
          );

          let t1 = new moment(n.first_time_node).clone();
          let t2 = new moment(n.total_period[1]).clone();
          while (t2.diff(t1) > 0) {
            this.time_node.push(t1.clone().format("YYYY/MM/DD HH:mm"));
            t1.add(n.duration, "days");
          }
          this.time_node.push(t2.format("YYYY/MM/DD HH:mm"));
        }
      },
    },
    voyage_accounts_opened_ids: {
      deep: true,
      handler: function (n, o) {
        this.voyage_accounts_opened_pos = [];
        n.forEach((id) => {
          let pos = this.voyage_accounts.findIndex((v) => v.id == id);
          this.voyage_accounts_opened_pos.push(pos);
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.summary_tab {
  position: relative;

  .right_menu {
    position: absolute;
    top: 200px;
    left: 200px;
    width: 300px;
    height: 100px;
    border-radius: 10px;
    background-color: seagreen;
    z-index: 99;
  }
}

.voyage_tab {
  position: relative;

  .float_menu {
    padding: 10px;
    position: fixed;
    bottom: 10%;
    right: 50px;
    z-index: 100;
    width: 380px;
    background-color: rgba($color: #fff, $alpha: 0.9);
    border-radius: 30px;
    border: 1px solid #aaa;
  }

  .float_button {
    position: fixed;
    bottom: 10%;
    right: 50px;
    z-index: 100;
  }
}

.col_height {
  height: 100%;
}

.accout_wrapper {
  width: 100%;
  margin: 50px auto;
  position: relative;

  .a-col-3 {
    text-align: center;
    vertical-align: bottom;
    background-color: aqua;
  }
}
</style>
